var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"drag-drop"}},[_c('draggable',{on:{"end":_vm.onEnd},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},[_c('transition-group',{staticClass:"row"},_vm._l((_vm.data),function(item){return _c('div',{key:item.uuid,staticClass:"col-sm-4 list-complete-item"},[_c('div',{staticClass:"box-detail"},[_vm._v(_vm._s(item.name))])])}),0)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-161e4c73","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partials/DragDrop.vue
// module id = 1937
// module chunks = 0